import Postmonger from 'vis-postmonger';

import { setActivity, setInteraction, setToken, types } from '../actions';

const connection = new Postmonger.Session();

export const postmongerMiddleware = store => next => action => {
  switch (action.type) {
    case types.JOURNEY_BUILDER_START:
      connection.trigger('ready');
      connection.on('clickedNext', () => {
        connection.trigger('nextStep');
      });
      connection.on('clickedBack', () => {
        connection.trigger('prevStep');
      });
      connection.trigger('requestTokens');
      connection.on('requestedTokens', tokens => store.dispatch(setToken(tokens)));

      connection.on('initActivity', activity => store.dispatch(setActivity(activity)));

      connection.trigger('requestInteraction');
      connection.on('requestedInteraction', interaction =>
        store.dispatch(setInteraction(interaction))
      );
      break;
    case types.JOURNEY_BUILDER_FINISH:
      connection.trigger('setActivityDirtyState', false);
      // now request that Journey Builder closes the inspector/drawer
      connection.trigger('requestInspectorClose');
      break;
    default:
      next(action);
      break;
  }
};

export default postmongerMiddleware;



// WEBPACK FOOTER //
// ./src/Root/RootStore/postmongerMiddleware.js